import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ spacing }) =>
  createStyles({
    menu: {
      '& .MuiMenu-list': {
        padding: spacing(0.8, 0),

        '& .MuiListItem-root': {
          letterSpacing: 0.5,
          gap: '1rem',
          paddingTop: spacing(1.3),
          paddingBottom: spacing(1.3),

          '& + .MuiListItem-root': {
            borderTop: '1px solid transparent',
            borderImage:
              'linear-gradient(90deg, transparent 10%, #CECFCE 10%, #CECFCE 90%, transparent 90%)',
            borderImageSlice: 1,
          },
        },
      },
    },
  }),
)
